export const resizeImageToDataUrl = async (
  image: any,
  newWidth: number
): Promise<string> => {
  const aspectRatio = image.width / image.height;
  const newHeight = newWidth / aspectRatio;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = newWidth;
  canvas.height = newHeight;

  if (ctx) {
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL(); // Return the resized image as DataURL
  }

  return "";
};

export const calculateTextWidth = (text: string, font: string) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (ctx) {
    ctx.font = font; // Set the font style
    return ctx?.measureText(text).width; // Return the width of the text
  }

  return 0; // Return 0 if context is not available
};